import React, { useEffect } from 'react';
import Splash from './Splash';
import { useSelector, useDispatch } from 'react-redux';
import { userStatus, checkAuthentication, splashLoadingStatus, loadingStatus, loggedInStatus } from '../features/general/generalSlice';
import Home from './Home';
import Welcome from './Welcome';
import { useLocation } from 'react-router-dom';
import Login from './Login';
import Signup from './Signup';
import Loader from './Loader';

const Layout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const _userStatus = useSelector(userStatus);
  const _loadingStatus = useSelector(loadingStatus);
  const _splashLoadingStatus = useSelector(splashLoadingStatus);
  const _loggedInStatus = useSelector(loggedInStatus);

  useEffect(() => {
    if(_userStatus === 'idle'){
      setTimeout(() => {
        dispatch(checkAuthentication());
      }, 2000);
    }
  }, [_userStatus, dispatch]);
  
  return (
    <>
      {_loadingStatus && <Loader />}
      <div className='App'>
        {_splashLoadingStatus && <Splash/>}
        {!_splashLoadingStatus && _loggedInStatus && <Home/>}
        {!_splashLoadingStatus && !_loggedInStatus && !['/login', '/signup'].includes(location.pathname) && <Welcome />}
        {!_splashLoadingStatus && !_loggedInStatus && ['/login'].includes(location.pathname) && <Login />}
        {!_splashLoadingStatus && !_loggedInStatus && ['/signup'].includes(location.pathname) && <Signup />}
      </div>
    </>
  )
}

export default Layout;